module.exports = __webpack_public_path__ + "static/media/AvenirNext-Italic.06fc0b69.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-Italic.eot
// module id = 74
// module chunks = 0